import React, { useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

import NewsContext from '../../context/news-context';
import useStyles from "../../styles/components/news/stylesNewsDetail";

const NewsDetailHolder = () => {
    const { newsContext } = useContext(NewsContext);
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Typography classes={{ root: classes.rootTypography }}>{newsContext.newsDetail.title}</Typography>
            <br />
            <div >
                {newsContext.newsDetail.updatedDate ?
                    <Typography classes={{ root: classes.rootTypographyDate }}>Published on {newsContext.newsDetail.updatedDate} by <span>{newsContext.newsDetail.updatedBy}</span></Typography>
                    :
                    <Typography classes={{ root: classes.rootTypographyDate }}>Published on {newsContext.newsDetail.createdDate} by  <span>{newsContext.newsDetail.createdBy}</span></Typography>
                }
            </div>
            <div className={classes.sunEditor}>
                <SunEditor
                    showToolbar={false}
                    enableToolbar={true}
                    disable={true}
                    setOptions={{
                        height: "100%",
                        resizingBar: false,
                    }}
                    toggleFullScreen={true}
                    setContents={newsContext.newsDetail.body}
                    showController={false}
                />
            </div>
        </div>
    );
};

export { NewsDetailHolder as default }

//<Typography classes={{ root: classes.rootTypography }}>{newsContext.newsDetail.title}</Typography>
//<img src={newsContext.newsDetail.bannerUrl} alt={newsContext.newsDetail.title} className={classes.image} />